import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

export const ProtectedRoute = ({ children, requiredRole, requiredRoles }) => {
  const { authenticated, loading, hasRole, hasAnyRole } = useAuth();

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900">
        <Loader2 className="w-12 h-12 animate-spin text-blue-600 dark:text-blue-400 mb-4" aria-hidden="true" />
        <p className="text-gray-600 dark:text-gray-400 text-sm" role="status" aria-live="polite">
          Loading...
        </p>
      </div>
    );
  }

  // If not authenticated, keycloak.login() in AuthContext will handle redirect
  // No need to navigate here - just show loading state
  if (!authenticated) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900">
        <Loader2 className="w-12 h-12 animate-spin text-blue-600 dark:text-blue-400 mb-4" aria-hidden="true" />
        <p className="text-gray-600 dark:text-gray-400 text-sm" role="status" aria-live="polite">
          Redirecting to login...
        </p>
      </div>
    );
  }

  // Check roles (supports both single role and multiple roles)
  if (requiredRole && !hasRole(requiredRole)) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (requiredRoles && !hasAnyRole(requiredRoles)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};
